// Language + route mapping helpers for the EN / DE bilingual site.
// English routes stay unchanged; German routes live under /de/...

export const EN_TO_DE = {
  "/": "/de",
  "/origins": "/de/ursprunge",
  "/session": "/de/sitzung",
  "/my-story": "/de/meine-geschichte",
  "/faq": "/de/faq",
  "/contacts": "/de/kontakt",
  "/field-notes": "/de/field-notes",
  "/impressum": "/de/impressum",
  "/payment/success": "/de/zahlung/erfolg",
  "/payment/cancel": "/de/zahlung/abbruch",
};

export const DE_TO_EN = Object.fromEntries(
  Object.entries(EN_TO_DE).map(([en, de]) => [de, en])
);

export const isDePath = (pathname) =>
  pathname === "/de" || pathname.startsWith("/de/");

export const getLang = (pathname) => (isDePath(pathname) ? "de" : "en");

// Given the current path, return its equivalent in the other language.
export const otherLangPath = (pathname) => {
  if (isDePath(pathname)) {
    return DE_TO_EN[pathname] || "/";
  }
  return EN_TO_DE[pathname] || "/de";
};
